export default "/images/candy-image-85.png?5088b1952d35762cd040a4209d501c61";